import { render } from "./ProductComments.vue?vue&type=template&id=bb0aa2de&scoped=true"
import script from "./ProductComments.vue?vue&type=script&lang=js"
export * from "./ProductComments.vue?vue&type=script&lang=js"

import "./ProductComments.vue?vue&type=style&index=0&id=bb0aa2de&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0aa2de"]])

export default __exports__